// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import { vi } from 'date-fns/locale';
// import { useEffect, useState } from 'react';
// import { FaTemperatureHigh } from 'react-icons/fa';
// import { IoWaterOutline } from 'react-icons/io5';
import { AiOutlineRight } from 'react-icons/ai';
// import { MainState } from '../../MainProvider';
import './styles.weather.scss';

// const variants = {
//     hidden: { x: "-100%" },
//     visible: { x: 0 },
// };

interface Props {
    currentWeather: any;
    toDayWeather: any;
}

const Weather = (props: Props) => {
    // const { typeNews, setTypeNews, footerHeight, setFooterHeight, topicContent, setTopicContent, topiclst, setTopiclst, clickedCluster, setClickedCluster } = MainState();
    function formatTime(dateString: string) {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = "0" + date.getMinutes();

        // Will display time in hh:mm format
        return hours + ':' + minutes.substr(-2);
    }


    return (
        <div className='main-weather'>
            <div className="main-weather-current">
                <div className="main-weather-current-left">
                    <div className="location">
                        {props.currentWeather?.name}
                    </div>
                    <div className="time">
                        {format(new Date(), 'EEEE, dd.MM', { locale: vi })}
                    </div>
                </div>
                <div className="main-weather-current-right">
                    <div className='weather-current-icon'>
                        <img src={`https://openweathermap.org/img/wn/${props.currentWeather?.weather[0].icon}.png`} alt="" />
                    </div>
                    <div className="temperature">
                        {Math.round(props.currentWeather?.main.temp)}°C
                    </div>
                </div>
            </div>
            <div className='main-weather-today'>
                {(props.toDayWeather && props.toDayWeather.length > 0) && props.toDayWeather.slice(2, 6).map((weather: any, index: number) => (
                    <div className="weather-today-item">
                        <div className="weather-today-item-time">
                            {formatTime(weather.dt_txt)}
                        </div>
                        <div className="weather-today-item-temp">
                            {Math.round(weather?.main.temp)}°C
                        </div>
                        <div className='weather-today-item-icon'>
                            <img src={`https://openweathermap.org/img/wn/${weather?.weather[0].icon}.png`} alt="" />
                        </div>
                    </div>
                ))}
            </div>
            <a href='https://openweathermap.org/' className='view-more-weather' >
                Thời tiết hôm nay
                <AiOutlineRight />
            </a>
        </div >
    )
}

export default Weather
